module.exports = __webpack_public_path__ + "img/no_goods.26f04b3d.png";